import $ from 'jquery';
import def from './selectionField.def.js';

$.widget('formBuilder.selectionField', def);



// WEBPACK FOOTER //
// ./src/widgets/selectionField.js